import React, { useContext, useEffect, useState } from "react";
import "./Footer.css";
import {
  faFacebookF,
  faGoogle,
  faInstagram,
  faLinkedinIn,
  faXTwitter,
} from "@fortawesome/free-brands-svg-icons";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Context } from "../../utils/context";
import { GetSocialLink } from "../../utils/apis/master/Master";

const Footer = () => {


  const {
    IMG_URL,
    appSetup
  } = useContext(Context);
  const navigate = useNavigate();


  const [socialLink, setSocialLink] = useState();
  const getAllSocialLink = async () => {
    const res = await GetSocialLink();

    if (res?.success) {
      setSocialLink(res?.data);
    } else {
      console.error('Error fetching  data:', res?.error);
    }
  }

  useEffect(() => {
    getAllSocialLink();
  }, []);
  return (
    <>
      <section className="footer">
        <div className="container">
          <div className="footer_logo_holder" onClick={() => navigate("/")}>
            <img
              src="/assets/images/header/infinity-logo.png"
              alt="footer-logo"
              className="footer_logo"
            />
          </div>

          <div className="row justify-content-center mt-5">
            <div className="col-lg-4 col-md-5 col-sm-6 col-6 mb-4 col_div">
              <h5 className="footer_section_title">Quick Links</h5>
              <div className="row">
                <div className="col-lg-6 col-md-6 col-sm-6 col-12 mb-2">
                  <div className=" quick_links">
                    {[
                      { label: "Home", path: "/" },
                      { label: "About Us", path: "/about-us" },
                      { label: "Contact Us", path: "/contact-us" },
                      { label: "Blogs", path: "/blogs" },
                    ].map((item) => (
                      <NavLink
                        key={item.path}
                        as={Link}
                        to={item.path}
                        className="footer_link"
                      >
                        {item.label}
                      </NavLink>
                    ))}
                  </div>
                </div>
                <div className="col-lg-6 col-md-6 col-sm-6">
                  <div className=" quick_links">
                    {[
                      { label: "Terms & Condition", path: "/terms-condition" },
                      { label: "Privacy Policy", path: "/privacy-policy" },
                      { label: "FAQs", path: "/faq" },
                    ].map((item) => (
                      <NavLink
                        key={item.path}
                        as={Link}
                        to={item.path}
                        className="footer_link"
                      >
                        {item.label}
                      </NavLink>
                    ))}
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-5 col-sm-6 col-6 mb-4 col_div">
              <h5 className="footer_section_title">Customer Support</h5>
              <div className="quick_links">
                <p className="footer_link">Email: {appSetup?.email || ""} </p>
                <p className="footer_link">Phone: {appSetup?.contact_no || ""}</p>
              </div>
            </div>

            <div className="col-lg-2 col-md-2 col-sm-12 col-12 mb-4 col_div">
              <h5 className="footer_section_title">Social Links</h5>
              <div className="quick_links icon_links">


                {socialLink?.map((item, index) => (
                  <a
                    key={index}
                    href={item.link}
                    className="footer_link"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <div className="footer_icon_hoder">

                      <img
                        src={IMG_URL + item.logo}
                        className="icon-image"
                      ></img>
                    </div>
                  </a>
                ))}
                {/* {[
                  { icon: faFacebookF, link: "https://www.facebook.com" },
                  { icon: faInstagram, link: "https://www.google.com" },
                  { icon: faXTwitter, link: "https://www.twitter.com" },
                  { icon: faLinkedinIn, link: "https://www.linkedin.com" },
                ].map((item, index) => (
                  <a
                    key={index}
                    href={item.link}
                    className="footer_link"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <div className="footer_icon_hoder">
                      <FontAwesomeIcon
                        icon={item.icon}
                        className="footer_icon"
                      />
                    </div>
                  </a>
                ))} */}
              </div>
            </div>
          </div>

          <div className="footer_text_div">
            <p className="footer_text">
              {appSetup?.address || ""}
            </p>
          </div>

          <hr className="divider" />

          <div className="footer_text_div">
            <p className="footer_text">
              ©2026 Infinity Ladakh Tour All Rights Reserved. Developed by
              <a
                href="https://profcymaglobal.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="link_text"
              >
                {" "}
                {""}
                Profcyma
              </a>
            </p>
          </div>
        </div>
      </section>
    </>
  );
};

export default Footer;
